module.exports = __webpack_public_path__ + "h5/img/dh32.c361e296.png";